import {invokeApi} from "../bl_libs/invokeApi";
import {use_e2ee} from "../utils/utils";
import {LOCAL_STORAGE_KEYS} from "../utils/constants";

export const createClientService = async (org_details) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/client/create',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };

    requestObj['postData'] = {
        ...org_details,
    }

    return invokeApi(requestObj, use_e2ee());
};

export const editClientService = async (org_code, org_details) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/client/edit',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };

    requestObj['postData'] = {
        org_code,
        ...org_details,
    }

    return invokeApi(requestObj, use_e2ee());
};

export const assignLicensesService = async (org_code, license_count) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/client/assign_licenses',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };

    requestObj['postData'] = {
        org_code,
        license_count
    }

    return invokeApi(requestObj, use_e2ee());
};


export const linkAssessmentService = async (org_code, dq_module_codes) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/client/link_assessment',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };

    requestObj['postData'] = {
        org_code,
        dq_module_codes,
    }

    return invokeApi(requestObj, use_e2ee());
};

export const getLinkedAssessmentService = async (org_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: `/dq_insider/dqin/client/get_linked_assessment/${org_code}`,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    return invokeApi(requestObj, use_e2ee());
};

export const listClientsService = async () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/client/list',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    return invokeApi(requestObj, use_e2ee());
};
